const getters = {
  terminal: state => state.app.terminal,
  appId: state => state.app.appId,
  isLogin: state => state.user.isLogin,
  token: state => state.user.token,
  info: state => state.user.info,
  name: state => state.user.name,
  language: state => state.user.language,
  languageOld: state => state.user.languageOld,
  subjectType: state => state.user.subjectType,
  exhibitionId: state => state.user.exhibitionId,
  exhibitorId: state => state.user.exhibitorId,
  visitorId: state => state.user.visitorId,
  fromUrl: state => state.user.fromUrl,
  invitationSource: state => state.user.invitationSource,
  advertisingSharing: state => state.user.advertisingSharing,
  checkBannedList: state => state.user.checkBannedList,
  config: state => state.config.configSwitch,
  servicePhone: state => state.config.servicePhone,
  serviceEmail: state => state.config.serviceEmail,
  loginAccount: state => state.login.loginAccount,
  loginType: state => state.login.loginType,
  inviteType: state => state.user.inviteType,
  imAccount: state => {
    if(state.user.info.userInfo) {
      return state.user.info.userInfo.imAccount
    } else {
      return {}
    }
  },
  headImage: state => {
    if(state.user.info.userInfo) {
      return state.user.info.userInfo.headImage
    } else {
      return ''
    }
  }
}
export default getters
